import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DashboardRepository } from '../../../infrastructure/repositories/dashboard.repository';
import { GetDashboardWidgetsResult } from './get-dashboard-widgets.result';

@Injectable({ providedIn: 'root' })
export class GetDashboardWidgetsUseCase {
  private readonly _repository = inject(DashboardRepository);

  public execute(): Observable<GetDashboardWidgetsResult> {
    return this._repository.getWidgets().pipe(map((widgets) => ({ widgets })));
  }
}
